var map = {
	"./plain-sticker-a.png": 126,
	"./plain-sticker-b.png": 127,
	"./plain-sticker-c.png": 128,
	"./plain-sticker-d.png": 129,
	"./plain-sticker-e.png": 130,
	"./plain-sticker-f.png": 131,
	"./plain-sticker-g.png": 132,
	"./plain-sticker-h.png": 133,
	"./plain-sticker-i.png": 134,
	"./plain-sticker-j.png": 135,
	"./plain-sticker-k.png": 136,
	"./plain-sticker-l.png": 137,
	"./plain-sticker-m.png": 138,
	"./plain-sticker-n.png": 139,
	"./plain-sticker-o.png": 140,
	"./plain-sticker-p.png": 141,
	"./plain-sticker-q.png": 142,
	"./plain-sticker-r.png": 143,
	"./plain-sticker-s.png": 144,
	"./plain-sticker-t.png": 145,
	"./plain-sticker-u.png": 146,
	"./plain-sticker-v.png": 147,
	"./plain-sticker-w.png": 148,
	"./plain-sticker-x.png": 149,
	"./plain-sticker-y.png": 150,
	"./plain-sticker-z.png": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 501;